import React, { Fragment } from "react";
import PropTypes from "prop-types";
import {
  TextField,
  Tooltip,
  IconButton,
  MenuItem,
  Typography,
} from "@material-ui/core";
import FilterIcon from "mdi-material-ui/FilterOutline";
import RefreshIcon from "mdi-material-ui/Refresh";

const C13DeliveryOrdersStatusDashboardFilter = (props) => {
  return (
    <Fragment>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          alignItems: "center",
        }}
      >
        <div>
          <Typography variant="h5" color="primary" style={{ fontWeight: 700 }}>
            Delivery Orders Status
          </Typography>
        </div>
        <div
          style={{
            display: "flex",
            width: "70%",
            justifyContent: "flex-end",
          }}
        >
          <div>
            <Tooltip title="Refresh Orders Data">
              <IconButton
                style={{ marginLeft: "-10px" }}
                onClick={() => props.getOrdersData()}
              >
                <RefreshIcon fontSize="default" color="primary" />
              </IconButton>
            </Tooltip>
          </div>
          <div>
            <Tooltip title="Table Filter">
              <IconButton
                style={{ marginLeft: "-10px" }}
                onClick={() => props.handleToggleTableFilter()}
              >
                <FilterIcon fontSize="default" color="primary" />
              </IconButton>
            </Tooltip>
          </div>
          <div
            style={{
              width: "30%",
            }}
          >
            <TextField
              select
              id="categoryId"
              name="categoryId"
              fullWidth
              label="Filter"
              size="small"
              variant="outlined"
              onChange={props.handleChange}
              value={props.state.categoryId}
              error={!!props.state.categoryIdError}
              helperText={props.state.categoryIdError}
              disabled={props.state.isLoading}
            >
              {props.state.categoriesData &&
                props.state.categoriesData.map((item) => {
                  return (
                    <MenuItem key={item.id} value={item.id}>
                      {item.label || ""}
                    </MenuItem>
                  );
                })}
            </TextField>
          </div>
          {/* <div>
            <Button
              style={{
                textTransform: "capitalize",
                marginLeft: 15,
                padding: 7.5,
                width: 110,
              }}
              color="primary"
              variant="contained"
            >
              Search
            </Button>
          </div> */}
        </div>
      </div>
    </Fragment>
  );
};

C13DeliveryOrdersStatusDashboardFilter.propTypes = {
  state: PropTypes.object,
  handleChange: PropTypes.func,
  handleToggleTableFilter: PropTypes.func,
  onNewItemButtonClick: PropTypes.func,
  getOrdersData: PropTypes.func,
};

C13DeliveryOrdersStatusDashboardFilter.defaultProps = {
  state: {},
  handleChange: (fn) => fn,
  handleToggleTableFilter: (fn) => fn,
  onNewItemButtonClick: (fn) => fn,
  getOrdersData: (fn) => fn,
};

export default C13DeliveryOrdersStatusDashboardFilter;
